<nav
  class="navbar navbar-expand-lg navbar-dark fixed-top"
  [ngClass]="{
    'bg-prep': environmentLabel == 'prep',
    'bg-dark': environmentLabel == 'prod',
    'bg-test': environmentLabel == 'test',
    'bg-dev': environmentLabel == 'dev',
    'bg-local': environmentLabel == 'local',
    'bg-new-auth': environmentLabel == 'new-auth',
    'h-90': innerWidth > 990,
  }"
>
  <head-logo></head-logo>
  <!-- Small width dropdown menu (tap-friendly for tablets) -->
  <div class="mobile-nav d-flex d-lg-none align-items-center">
    <head-action-buttons></head-action-buttons>
    <head-login></head-login>
    <head-menu-mobile></head-menu-mobile>
  </div>
  <div
    class="collapse navbar-collapse full-width flex-column align-items-center h-80"
    id="navbarSupportedContent"
  >
    <div
      class="row d-flex align-items-start justify-content-end full-width h-45"
    >
      <div class="col pr-0">
        <head-login></head-login>
      </div>
    </div>
    <div
      class="row full-width d-flex justify-content-between align-items-center"
      [ngClass]="{ 'top-10': innerWidth > 990 }"
    >
      <div class="col d-flex align-items-center pt-0" id="navbar">
        <head-menu class="full-width"></head-menu>
      </div>
      <head-action-buttons
        class="max-width ml-3"
        *ngIf="innerWidth > 990"
        #actions
      ></head-action-buttons>
    </div>
  </div>

  <div *ngIf="environmentLabel != 'prod'" class="banner">
    {{ environmentLabel }}
  </div>
</nav>
